
import { useState, FormEvent } from 'react';
import { useTranslation } from 'react-i18next';

export default function Formulario() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    nome: '',
    empresa: '',
    area: '',
    objetivo: '',
    orcamento: '',
    telefone: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formElement = e.target as HTMLFormElement;
      const formDataToSend = new FormData(formElement);

      const response = await fetch('https://readdy.ai/api/form/d61ijrccm4ll99gupit0', {
        method: 'POST',
        body: new URLSearchParams(formDataToSend as any)
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          empresa: '',
          area: '',
          objetivo: '',
          orcamento: '',
          telefone: ''
        });

        setTimeout(() => {
          setSubmitStatus('idle');
        }, 5000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <section id="formulario" className="py-24 lg:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-black mb-6">
            {t('formulario.titulo')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('formulario.subtitulo')}
          </p>
        </div>

        <form
          id="orcamento-form"
          onSubmit={handleSubmit}
          className="bg-gray-50 p-8 lg:p-12 rounded-lg shadow-lg"
          data-readdy-form
        >
          <div className="grid md:grid-cols-2 gap-6 mb-6">
            <div>
              <label htmlFor="nome" className="block text-sm font-semibold text-black mb-2">
                {t('formulario.nome')} *
              </label>
              <input
                type="text"
                id="nome"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-black focus:ring-1 focus:ring-black outline-none transition-colors text-sm"
                placeholder={t('formulario.nomePlaceholder')}
              />
            </div>

            <div>
              <label htmlFor="empresa" className="block text-sm font-semibold text-black mb-2">
                {t('formulario.empresa')} *
              </label>
              <input
                type="text"
                id="empresa"
                name="empresa"
                value={formData.empresa}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-black focus:ring-1 focus:ring-black outline-none transition-colors text-sm"
                placeholder={t('formulario.empresaPlaceholder')}
              />
            </div>
          </div>

          <div className="mb-6">
            <label htmlFor="area" className="block text-sm font-semibold text-black mb-2">
              {t('formulario.area')} *
            </label>
            <select
              id="area"
              name="area"
              value={formData.area}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-black focus:ring-1 focus:ring-black outline-none transition-colors text-sm cursor-pointer"
            >
              <option value="">{t('formulario.areaPlaceholder')}</option>
              <option value="Restauração">{t('formulario.restauracao')}</option>
              <option value="Hotelaria">{t('formulario.hotelaria')}</option>
              <option value="Moda">{t('formulario.moda')}</option>
              <option value="Beleza e Bem-estar">{t('formulario.beleza')}</option>
              <option value="Comércio Local">{t('formulario.comercio')}</option>
              <option value="Serviços Profissionais">{t('formulario.servicosPro')}</option>
              <option value="Outro">{t('formulario.outro')}</option>
            </select>
          </div>

          <div className="mb-6">
            <label htmlFor="objetivo" className="block text-sm font-semibold text-black mb-2">
              {t('formulario.objetivo')} *
            </label>
            <textarea
              id="objetivo"
              name="objetivo"
              value={formData.objetivo}
              onChange={handleChange}
              required
              maxLength={500}
              rows={4}
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-black focus:ring-1 focus:ring-black outline-none transition-colors text-sm resize-none"
              placeholder={t('formulario.objetivoPlaceholder')}
            ></textarea>
            <p className="text-xs text-gray-500 mt-1">
              {formData.objetivo.length}/500 {t('formulario.caracteres')}
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <div>
              <label htmlFor="orcamento" className="block text-sm font-semibold text-black mb-2">
                {t('formulario.orcamento')} *
              </label>
              <select
                id="orcamento"
                name="orcamento"
                value={formData.orcamento}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-black focus:ring-1 focus:ring-black outline-none transition-colors text-sm cursor-pointer"
              >
                <option value="">{t('formulario.areaPlaceholder')}</option>
                <option value="500€ - 1.000€">500€ - 1.000€</option>
                <option value="1.000€ - 2.500€">1.000€ - 2.500€</option>
                <option value="2.500€ - 5.000€">2.500€ - 5.000€</option>
                <option value="> 5.000€">&gt; 5.000€</option>
              </select>
            </div>

            <div>
              <label htmlFor="telefone" className="block text-sm font-semibold text-black mb-2">
                {t('formulario.telefone')} *
              </label>
              <input
                type="tel"
                id="telefone"
                name="telefone"
                value={formData.telefone}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-black focus:ring-1 focus:ring-black outline-none transition-colors text-sm"
                placeholder={t('formulario.telefonePlaceholder')}
              />
            </div>
          </div>

          {submitStatus === 'success' && (
            <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
              <p className="text-green-800 text-sm font-medium">{t('formulario.sucesso')}</p>
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-800 text-sm font-medium">{t('formulario.erro')}</p>
            </div>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-black text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
          >
            {isSubmitting ? t('formulario.enviando') : t('formulario.enviar')}
          </button>
        </form>
      </div>
    </section>
  );
}
